import React from 'react';

import { NoticeComponent, UiComponent } from 'components';

function List() {
  return (
    <>
      <UiComponent.PageTitle>공지목록</UiComponent.PageTitle>
      <NoticeComponent.Filter />
      <NoticeComponent.List />
    </>
  );
}

export default List;
